import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import {
  Firestore,
  connectFirestoreEmulator,
  getFirestore,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyB3sdVNt2sOxtNQEh-Kx9LA52oOULNlspg",
  authDomain: "announce-it-73174.firebaseapp.com",
  projectId: "announce-it-73174",
  storageBucket: "announce-it-73174.appspot.com",
  messagingSenderId: "485984265767",
  appId: "1:485984265767:web:6f4b6d00141845e79e9002",
  measurementId: "G-5BSCJZE1Y9",
};

let db;
let isInitialized = false;

if (!isInitialized) {
  (() => {
    const app = initializeApp(firebaseConfig);
    const auth = getAuth(app);
    db = getFirestore(app);
    // if (window.location.hostname === "localhost") {
    //   connectAuthEmulator(auth, "http://localhost:9099");
    //   connectFirestoreEmulator(db, "localhost", 8080);
    // }
    isInitialized = true;
  })();
}

export { db };
